import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Tooltip as NextTooltip } from '@nextui-org/react';

import style from './tooltip.module.scss';

type Props = {
  placement?: 'top' | 'bottom';
  content: ReactNode | string;
};

const Tooltip: FC<PropsWithChildren<Props>> = ({
  placement = 'bottom',
  content,
  children,
}) => {
  return (
    <NextTooltip
      portalClassName={style['tooltip']}
      placement={placement}
      content={content}
      rounded={false}
      hideArrow={false}
      css={{
        borderRadius: '0px',
        background: 'var(--purple-500)',
        maxWidth: '14rem',
      }}
    >
      {children}
    </NextTooltip>
  );
};

export default Tooltip;
